import $ from 'jquery';
import { updateTextOnly } from '@/js/modules/update_text_only';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function getFlatRateServiceIds() {
    const params = queryString();
    let ids = (params['ids'] || '').split(',');
    ids = ids.filter((id) => id);

    return new Set(ids);
  }

  function setFlatRateServiceIds(ids) {
    const params = queryString();

    let url = null;
    params['ids'] = Array.from(ids).join(',');

    if (Object.keys(params).length > 0 && $.param(params).length > 0) {
      url = '?' + $.param(params);
    } else {
      url = window.location.pathname;
    }

    window.history.replaceState(null, '', url);
  }

  function updateFlatRateServicesControls() {
    const selectedCheckboxesLength = $('.checkbox--flat-rate-services:checked').length;
    const flatRateServicesCount = $('.data-table__tr').length;
    const totalSelectedFlatRateServices = getFlatRateServiceIds().size;

    if (totalSelectedFlatRateServices > 0) {
      updateTextOnly(
        $('.h-d-button--delete-flat-rate-services'),
        `Delete (${totalSelectedFlatRateServices})`
      ).removeClass('hide');

      $('.flat-rate-services-search-form').hide();
    } else {
      $('.h-d-button--delete-flat-rate-services').addClass('hide');
      $('.flat-rate-services-search-form').show();
    }

    // check/uncheck the "check all" checkbox based on count
    $('.checkbox--flat-rate-services-check-all').prop(
      'checked',
      selectedCheckboxesLength === flatRateServicesCount
    );
  }

  $(document).ready(() => {
    getFlatRateServiceIds().forEach((flatRateServiceId) => {
      $(`.data-table__tr[data-id=${flatRateServiceId}]`)
        .find('.checkbox--flat-rate-services')
        .prop('checked', true);
    });
    updateFlatRateServicesControls();

    $(document).on($.modal.CLOSE, '.modal--flat-rate-service-form', (e) => {
      $(e.target).remove();
    });
  });

  $(document).on('change', '.checkbox--flat-rate-services', (e) => {
    const ids = getFlatRateServiceIds();
    const id = String($(e.target).closest('.data-table__tr').data('id'));

    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    if ($(e.target).is(':checked')) {
      ids.add(id);
    } else {
      ids.delete(id);
    }
    const newIds = Array.from(ids).join(',');

    $('.pagination a').each(function (index, link) {
      const url = new URL(link.href);
      const params = parseQuery(url.search);
      params['ids'] = newIds;
      url.search = '?' + $.param(params);
      link.href = url.href;
    });

    setFlatRateServiceIds(ids);
    updateFlatRateServicesControls();
  });

  $(document).on('change', '.checkbox--flat-rate-services-check-all', (e) => {
    $('.checkbox--flat-rate-services').prop('checked', $(e.target).prop('checked')).change();

    updateFlatRateServicesControls();
  });

  $(document).on('click', '.h-d-button--delete-flat-rate-services', (e) => {
    const selectedFlatRateServiceIds = Array.from(getFlatRateServiceIds());

    let bulkDeleteUrl = $(
      '.modal--delete-flat-rate-services-confirmation .d-button--confirm-delete'
    ).attr('href');

    if (/\?flat_rate_service_ids=.+$/.test(bulkDeleteUrl)) {
      bulkDeleteUrl = bulkDeleteUrl.replace(/\?flat_rate_service_ids=.+$/, '');
    }

    bulkDeleteUrl = `${bulkDeleteUrl}?flat_rate_service_ids=${selectedFlatRateServiceIds}`;

    $('.modal--delete-flat-rate-services-confirmation .d-button--confirm-delete').attr(
      'href',
      bulkDeleteUrl
    );

    $('.modal--delete-flat-rate-services-confirmation .modal__header').text(
      `Are you sure you want to delete ${selectedFlatRateServiceIds.length} selected services?`
    );

    $('.modal--delete-flat-rate-services-confirmation').modal();
  });

  $(document).on('click', '.flat-rate-services-search-form__clear', (e) => {
    const $el = $(e.target);
    $el.siblings('.flat-rate-services-search-form__field').val('');
    $el.parents('.flat-rate-services-search-form').submit();
  });

  $(document).on('change', 'input.field--flat-rate-service-image', (e) => {
    const $el = $(e.target);
    const $wrapper = $el.parents('.flat-rate-service-form__image-field-with-preview');
    const $preview = $wrapper.find('img.flat-rate-service-form__image-preview');
    const $removeImageFlagInput = $wrapper.find('input[name="remove_image"]');

    $preview[0].src = URL.createObjectURL(e.target.files[0]);
    $preview.show();

    $wrapper.find('.flat-rate-service-form__image-placeholder').addClass('hide');

    $wrapper
      .find(
        '.flat-rate-service-form__image-remove-separator, .delete-flat-rate-image, .delete-flat-rate-image i'
      )
      .show();

    if ($removeImageFlagInput.length > 0) {
      $removeImageFlagInput.val('false');
    }
  });

  $(document).on('click', '.delete-flat-rate-image', (e) => {
    const $el = $(e.target);
    const $wrapper = $el.parents('.flat-rate-service-form__image-field-with-preview');
    const $removeImageFlagInput = $wrapper.find('input[name="remove_image"]');
    const $imageFileInput = $wrapper.find('input.field--flat-rate-service-image');

    $wrapper
      .find('.field--flat-rate-service-image, .flat-rate-service-form__image-placeholder')
      .removeClass('hide');

    $wrapper
      .find(
        '.flat-rate-service-form__image-preview, .flat-rate-service-form__existing-image-name, .flat-rate-service-form__image-remove-separator'
      )
      .hide();

    $imageFileInput.val('');

    if ($removeImageFlagInput.length > 0) {
      $removeImageFlagInput.val('true');
    }

    $el.hide();
  });

  $(document).on('click', '.p-button--flat-rate-service-form', (e) => {
    const $form = $(e.target).closest('form');
    const name = $form.find('.field--flat-rate-service-name').val();
    const clientPrice = $form.find('.field--flat-rate-service-client-price').val();
    $form.find('.error-message').hide();

    let halt = false;

    if (name.trim().length === 0) {
      $form.find('.error-message--flat-rate-service-name').html('Please enter the name').show();
      halt = true;
    }

    if (clientPrice.length === 0 || parseFloat(clientPrice) <= 0) {
      $form
        .find('.error-message--flat-rate-service-client-price')
        .html('Please enter the client price')
        .show();
      halt = true;
    }

    if (!isValidFlatRateServiceClientPrice(clientPrice)) {
      $form
        .find('.error-message--flat-rate-service-client-price')
        .html('Please enter a valid client price')
        .show();
      halt = true;
    }

    if (halt) {
      return false;
    }

    $form.submit();
  });

  const isValidFlatRateServiceClientPrice = (clientPrice) => {
    return /^\d{1,6}(\.\d{1,2})?$/.test(clientPrice);
  };
});
